import styled, { css } from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        padding: 40px;
        background-color: ${({ theme }) => theme.color.white};
        border-radius: 16px;
    `,

    "RadioDiv": styled.div`
        display: flex;
        gap: 16px;
    `,
    "Radio": styled.button`
        display: flex;
        align-items: center;
        gap: 8px;
    `,
}